import React from 'react';
import '../css/Slideshow.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import Slideshow from './Slideshow';


/**
 * Slideshow component
 */
class SlideshowMix extends Slideshow{
  static displayName = 'SlideshowMix';

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
  }

 
  getIframeAttribute(iframe){
    var temp = document.createElement("div");
    temp.innerHTML  = iframe;
    temp = temp.firstElementChild.attributes; 

    //put the attributes in a an array
    var list = Object.keys(temp).map( function( index ) { return temp[ index ] } );

    // Get attributes
    const width = list.find(item=> item.name=='width').value;
    const height = list.find(item=> item.name=='height').value;
    const src = list.find(item=> item.name=='src').value;
    const allow = list.find(item=> item.name=='allow').value;

    return {
      width: width,
      height: height,
      src: src,
      allow: allow
    };
  }
  /**
   * @override
   */
  getItems(){
    let items = this.props.slideshow.items.map((item) => {
        let itemData = false;
        if(item.type=='image'){
            itemData = {
                name: item.title,
                original: this.imageUrl(item.image)
            }
        }else{
            // const attributes = this.getIframeAttribute(item.video);
            console.log(item.video);
            itemData = {
                name: item.title,
                renderItem: ()=>{
                    return <div className={`${this.className}__video`}>
                      <iframe src={item.video} frameBorder="0" allowFullScreen></iframe>
                    </div>
                }
            }
        }
        return itemData
    })
    return items;
  }
  /**
   * @override
   */
  getCurrentTitle(){
    return this.state.items[this.state.currentIndex].name 
  }

}

export default SlideshowMix;

